import React from "react";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import umanizzaDataSenzaOre from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import ImgArt from "./ImgArt";

function RiquadrinoArticolo({
    articolo,
    funzioneScegliID,
    scelto
}) {

    const {
        inputClassesNOW,
        classiTastoSblocco,
        buttonClassesWhiteRound
    } = stilePulsanti

    /* onClick={(e) => funzioneScegliID(articolo["ID Articolo"],"idArticolo",3)} */

    const statoWebModaCodice =
        articolo?.moda_stato_web_codice ?? articolo?.["moda_stato_web_codice"];
    const statoWebModaDescrizione =
        articolo?.moda_stato_web_descrizione ?? articolo?.["moda_stato_web_descrizione"];
    const statoWebModa = (statoWebModaCodice || statoWebModaDescrizione) && (
        <div className="w-100 mt2 f7">
            <span className="dib br2 bg-blue white b ph2 pv1 mr2">
                {statoWebModaCodice || "-"}
            </span>
            <span>{statoWebModaDescrizione || "-"}</span>
        </div>
    );
   

        if (scelto) {
            return(
                <div className="sfondoBiancoTema br4 pa2 flex flex-wrap items-center justify-center">
                            {(articolo?.["Cod Viglietti Sport"] || articolo?.codVS || articolo?.codiceVS || (articolo.prodIDps && articolo.imgIDps)) ? <div className="w-30 mb3">
                                <ImgArt 
                                    prodIDps={articolo.prodIDps}
                                    imgIDps={articolo.imgIDps}
                                    fonte={articolo.fonte || articolo.fonteOrdine}
                                    codVS={articolo?.["Cod Viglietti Sport"] || articolo?.codVS || articolo?.codiceVS}
                                    size="small_default"/><br/>
                            </div>
                            : <div className="w-100"></div>                    
                            }
                            <div className="w-100">
                                {articolo["Descrizione Articolo"]}
                            </div>
                            {statoWebModa}
                </div>
            )
        } else {
            return(
                <div
                className={"sfondoBiancoTema br4 pa2 flex flex-wrap mb3"}
            >
                <div className="flex flex-wrap w-100 bordoColAlt items-center justify-center">
                            {(articolo?.["Cod Viglietti Sport"] || articolo?.codVS || articolo?.codiceVS || (articolo.prodIDps && articolo.imgIDps)) ? <div className="w-30 mb3">
                                <ImgArt 
                                    prodIDps={articolo.prodIDps}
                                    imgIDps={articolo.imgIDps}
                                    fonte={articolo.fonte || articolo.fonteOrdine}
                                    codVS={articolo?.["Cod Viglietti Sport"] || articolo?.codVS || articolo?.codiceVS}
                                    size="small_default"/><br/>
                            </div>
                            : <div className="w-30"></div>                    
                            }
                            <div className="w-70">
                                {articolo["Descrizione Articolo"]}
                            </div> 
                    {statoWebModa}
                    <div className="w-100 tc">
                            <button
                            className={stilePulsanti.buttonClassesWhite}
                            onClick={(e) => funzioneScegliID(articolo["ID Articolo"],"idArticolo",3,"articolo",articolo)}>
                                SCEGLI
                            </button>
                    </div>
                </div>
            </div>
            )
        }

    
}

export default RiquadrinoArticolo;
